module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Sarmenstorf_AG-52e06d9dbd0d3499ab754e6ea9a85ac7.svg";